export default __webpack_public_path__ + "static/media/f.cae1f0fb.svg";